import Banner from 'components/Banner';
import Dashboard from 'components/Dashboard';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../hooks/hooks';
import { menuRoutes } from '../../router/router';


const Body = () => {

    const user = useAppSelector(x => x.authentication.user);

    return (
        <>
            {
                !user
                    ? <Navigate to={menuRoutes[1].to} />
                    : <>
                        <Banner />
                        <Dashboard />
                    </>
            }
        </>
    );
}

export default Body;
